import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import BookConsultationButton from "@/components/feature/BookConsultationButton";
import AnnouncementBanner from "@/components/feature/AnnouncementBanner";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "auto"
    });
  }, [pathname]);

  return (
    <>
      <AnnouncementBanner />
      <AppRoutes />
      <BookConsultationButton />
    </>
  );
}

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <ScrollToTop />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
